import NamedDto from 'modules/base/dto/NamedDto';

export default class PredictionModelSummaryDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.project = null;
		/** @type {string} */
		this.metadataJson = null;
	}

	/**
	 * @typedef {Object} _PredictionModelSummaryDtoProps
	 * @property {number} project
	 * @property {string} metadataJson
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PredictionModelSummaryDtoProps} PredictionModelSummaryDtoProps
	 */
	/**
	 * @param {PredictionModelSummaryDtoProps} props
	 * @returns {PredictionModelSummaryDto}
	 */
	setup(props) {
		super.setup(props);
		this.project = props.project;
		this.metadataJson = props.metadataJson;
		return this;
	}
}
